export default __webpack_public_path__ + "images/product/skin_types/combo-69f1ef7bfaefbe03d28e71160490224c.svg";